module.exports = __webpack_public_path__ + "img/48.0c74ae9e.jpg";